import { render, staticRenderFns } from "./HorizontalNavMenuGroup.vue?vue&type=template&id=36d53c66&scoped=true"
import script from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=0&id=36d53c66&prod&lang=scss"
import style1 from "./HorizontalNavMenuGroup.vue?vue&type=style&index=1&id=36d53c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d53c66",
  null
  
)

export default component.exports